import { IGlobalAlert } from 'domain/globalAlerts/types';
import { AppState } from 'domain/reducers';
import { peek } from 'libs/selectors';
import { createSelector } from 'reselect';

const baseSelector = (state: AppState) => state.globalAlerts;

export const globalAlertsIsLoadingSelector = createSelector(baseSelector, peek('loading'));

export const globalAlertsIsLoadedSelector = createSelector(baseSelector, peek('isLoaded'));

const globalAlertsListSelector = createSelector(baseSelector, peek('alerts'));

const globalAlertsDismissedIdsSelector = createSelector(baseSelector, peek('dismissedIds'));

// Drop alerts dismissed in-session (optimistic close).
export const globalAlertsVisibleSelector = createSelector(
  globalAlertsListSelector,
  globalAlertsDismissedIdsSelector,
  (alerts: IGlobalAlert[], dismissedIds: number[]): IGlobalAlert[] =>
    alerts.filter((alert) => !dismissedIds.includes(alert.id))
);
